// Copied from rakerone-web/src/components/code/code-view.tsx (ClientOnly dropped:
// this SPA is ssr:false, so lazy + Suspense is the whole story).
import { lazy, type ReactNode, Suspense } from 'react'

import { cn } from '@/lib/utils'

import { DARK_THEME_BACKGROUND } from './themes'

const ShikiCode = lazy(() => import('./code-view-shiki'))

export type CodeViewLang = 'json' | 'bash' | 'typescript'

export function PlainCode({ code, dark = false }: { code: string; dark?: boolean }) {
  return (
    <pre
      className={cn(
        'overflow-x-auto p-3 font-mono text-xs',
        dark ? 'text-white/70' : 'text-muted-foreground',
      )}
    >
      {code}
    </pre>
  )
}

export function CodeView({
  code,
  lang = 'json',
  actions,
  theme = 'auto',
  className,
}: {
  code: string
  lang?: CodeViewLang
  /** Pinned to the top-right corner, outside the scroll container. */
  actions?: ReactNode
  theme?: 'auto' | 'dark'
  className?: string
}) {
  const dark = theme === 'dark'
  const fallback = <PlainCode code={code} dark={dark} />
  return (
    <div className={cn('relative min-w-0', className)}>
      {actions ? <div className="absolute top-2 right-2 z-10">{actions}</div> : null}
      <div
        className={cn(
          'min-w-0 overflow-auto rounded-md',
          !dark && 'border border-border',
          className,
        )}
        style={dark ? { backgroundColor: DARK_THEME_BACKGROUND } : undefined}
      >
        <Suspense fallback={fallback}>
          <ShikiCode code={code} lang={lang} forceDark={dark} />
        </Suspense>
      </div>
    </div>
  )
}
